const appendUTM = (checkout, utmParams) => {
  if (checkout.search) {
    checkout.search = `${checkout.search}&${utmParams.replace('?', '')}`
  } else {
    checkout.search = utmParams
  }
  return checkout.search
}
export const utmHelper = {appendUTM}
